import axios from "axios";

export interface ForumRegisterUser {
  displayName: string;
  email: string;
  password: string;
  profileImage: string;
  role: string;
}

export interface ForumUpdateUser {
  displayName?: string;
  id?: string;
  profileImage?: string;
  password: string;
  email: string;
  bio: string;
}

const TOKEN_KEY = "forumtoken";

const FORUM_URL = `https://forum.ieeeinnovationnation.com`;

export interface ForumLoginUser {
  email: string;
  password: string;
}

export default class ForumUtils {
  public static login(
    payload: ForumLoginUser,
    onFinished: (data: any) => void,
    onError: (err: any) => void,
    gotoForum: boolean = false
  ) {
    axios
      .post(
        !process.env.NODE_ENV || process.env.NODE_ENV === "development"
          ? `/api/user/login`
          : `${FORUM_URL}/api/user/login`,
        {},
        {
          headers: {
            Username: payload.email,
            Password: payload.password,
          },
        }
      )
      .then((res) => {
        sessionStorage.setItem(TOKEN_KEY, JSON.stringify(res.data));
        onFinished(res.data);
        if (gotoForum) this.goToForum(res.data);
      })
      .catch((error) => {
        onError(Error);
      });
  }

  public static register(
    payload: ForumRegisterUser,
    saveForumPasswordFunction: firebase.functions.HttpsCallable,
    onFinished: (data: any) => void,
    onError: (err: any) => void,
    gotoForum: boolean = false
  ) {
    axios
      .post(
        !process.env.NODE_ENV || process.env.NODE_ENV === "development"
          ? `/api/user/register`
          : `${FORUM_URL}/api/user/register`,
        payload
      )
      .then((res) => {
        saveForumPasswordFunction(payload.password)
          .then(() => {
            sessionStorage.setItem(TOKEN_KEY, JSON.stringify(res.data));
            onFinished(res.data);
            if (gotoForum) this.goToForum(res.data);
          })
          .catch((err) => {
            onError(err);
          });

        // endcode ---> window.atob( encodedString )
      })
      .catch((err) => {
        onError(err);
      });
  }

  public static clearForumData() {
    sessionStorage.removeItem(TOKEN_KEY);
  }

  public static updateUser(
    payload: ForumUpdateUser,
    onFinished: () => void,
    onError: (err: any) => void
  ) {
    this.getForumToken(
      { email: payload.email, password: payload.password || "" },
      (token) => {
        axios
          .put(
            !process.env.NODE_ENV || process.env.NODE_ENV === "development"
              ? `/api/users/`
              : `${FORUM_URL}/api/users/`,
            {
              displayName: payload.displayName,
              profileImage: payload.profileImage,
              id: this.getForumUserId(),
              bio: payload.bio,
              username: payload.displayName,
              fullName: payload.displayName,
              school: "",
              mobile: "",
              enableAdvertisors: false,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then(() => {
            onFinished();
          })
          .catch((err) => {
            onError(err);
          });
      }
    );
  }

  public static getForumDataIfAailable(): string | null {
    return sessionStorage.getItem(TOKEN_KEY);
  }

  public static getForumUserId(): string {
    const data = this.getForumDataIfAailable() as any;
    return JSON.parse(data).currentUser.id;
  }

  public static getForumToken(
    login: ForumLoginUser,
    onFinished: (token: string) => void
  ): void {
    const data = this.getForumDataIfAailable();
    if (data) {
      onFinished(JSON.parse(data).session.token);
    } else {
      this.login(
        login,
        (data) => {
          onFinished(data.session.token);
        },
        () => {
          console.log("login error");
        }
      );
    }
  }

  public static goToForum(data: any) {
    window.open(
      encodeURI(
        `${FORUM_URL}/authwithtoken/${window
          .btoa(data)
          .replace("/", "%%%")}`
      )
    );
  }
}
